import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-now",
  "use": "icon-icon-now-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-now\"><g fill=\"#2E5BFD\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M6.48 3.491v2.65l1.416 1.34L6.74 8.637l-1.895-1.82V3.492z\" /><path d=\"M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol